module.exports = __webpack_public_path__ + "img/zixun@2x.612577db.png";